<template>
  <BaseTable
    :headers="[
      $t('global.id'),
      $t('global.supplier'),
      $t('global.created'),
      $t('global.quantity'),
      $t('global.status'),
    ]"
    :rows="
      (stockOrders || []).map((stockOrder) => ({
        id: stockOrder.id,
        routerLink: {
          name: stockOrder.status === 'open' ? 'products-order-build' : 'stock-order',
          params: {
            stockOrderId: stockOrder.id
          }
        },
        cells: [
          stockOrder.cid,
          stockOrder.supplier?.name,
          filters.dateTime(stockOrder.createdAt),
          $t('products.products_amount', { amount: stockOrder.quantity }),
          {
            label: stockOrder.status
          }
        ],
        actions: getActions(),
      }))
    "
    @action="onAction"
    v-test="'stock-orders'"
  ></BaseTable>
</template>

<script
  setup
  lang="ts"
>
import { useMutation } from '@vue/apollo-composable';
import { inject } from 'vue';
import { useI18n } from 'vue-i18n';
import filters from '@/filters';
import { flash, modal } from '@/helpers/ui';
import { DELETE_STOCK_ORDER } from './graphql';

const { t } = useI18n();

interface StockOrderItem {
  id: string;
  cid: string;
  createdAt: string;
  quantity: number;
  status: string;
  supplier?: {
    id: string;
    name: string;
  };
}

const stockOrders = inject<Ref<StockOrderItem[]>>('page-items');

const getActions = () => [
  {
    name: 'delete',
    icon: 'delete',
    label: t('global.actions.delete'),
  },
];

const deleteStockOrder = (id: number) => {
  const { mutate, onDone } = useMutation(DELETE_STOCK_ORDER, {
    update(cache) {
      const cacheId = `StockOrder:${id}`;
      cache.evict({ id: cacheId, broadcast: false });
      cache.gc();
    },
  });

  onDone(() => {
    flash(t('global.flash.stock_order_deleted'));
  });

  mutate({
    input: {
      id,
    },
  });
};

const onAction = ({ id, option }: { id: number; option: string }) => {
  if (option === 'delete') {
    modal('confirmation', { type: 'delete' }).then(() => {
      deleteStockOrder(id);
    });
  }
};
</script>
